"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", " !important;\n  padding-top: ", " !important;\n  padding-bottom: ", " !important;\n\n  span {\n    color: ", " !important;\n    font-weight: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledMenuItem = (0, _styledComponents.default)(function (_ref) {
  var spacingSubItem = _ref.spacingSubItem,
      spacing = _ref.spacing,
      depth = _ref.depth,
      selected = _ref.selected,
      props = _objectWithoutProperties(_ref, ["spacingSubItem", "spacing", "depth", "selected"]);

  return _react.default.createElement(_MenuItem.default, props);
})(_templateObject(), function (props) {
  return "".concat(props.spacing + props.depth * props.spacingSubItem, "px");
}, function (props) {
  return "".concat(props.spacingSubItem - 2, "px");
}, function (props) {
  return "".concat(props.spacingSubItem - 2, "px");
}, function (props) {
  return props.depth ? props.theme.palette.black.main : props.theme.palette.black.dark;
}, function (props) {
  return props.selected ? 'bold' : 'normal';
});
StyledMenuItem.defaultProps = {
  spacing: 16,
  spacingSubItem: 8
};
var _default = StyledMenuItem;
exports.default = _default;